import { Phone, Clock, ShieldCheck, FileText, HeartHandshake } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { BookingForm } from "@/components/BookingForm";
import { CONTACT } from "@/lib/site";

const ASSURANCES = [
    { icon: Phone, text: "A named travel designer calls you back — not a bot, not a queue." },
    { icon: FileText, text: "Free, itemised itinerary and quote within 24 hours." },
    { icon: ShieldCheck, text: "No advance payment needed to start planning." },
    { icon: HeartHandshake, text: "Amend or cancel easily — terms shared upfront, in writing." },
];

const Book = () => (
    <>
        <PageHeader
            eyebrow="Online Booking"
            title="Begin your journey"
            description="Share your travel dream below. Our designer will craft a tailor-made plan and quote — usually within a day."
        />
        <section className="py-20 lg:py-28">
            <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-3 lg:gap-16 lg:px-8">
                <div className="lg:col-span-2">
                    <BookingForm />
                </div>
                <div>
                    <Reveal delay={0.1}>
                        <div className="rounded-2xl bg-navy p-8 text-ivory" data-testid="book-aside-card">
                            <h2 className="font-serif text-2xl font-semibold">Prefer to talk?</h2>
                            <div className="gold-rule mt-5" />
                            <p className="mt-6 text-sm leading-relaxed text-ivory/70">
                                Our travel designers are a call or message away during office hours — and our
                                helpline answers around the clock for travellers on the road.
                            </p>
                            <div className="mt-8 space-y-3">
                                <a
                                    href={CONTACT.phoneHref}
                                    data-testid="book-aside-call-button"
                                    className="flex items-center justify-center gap-2 rounded-full bg-brass px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-300 hover:bg-brass-dark"
                                >
                                    <Phone className="h-4 w-4" />
                                    Call {CONTACT.phoneDisplay}
                                </a>
                                <a
                                    href={CONTACT.whatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="book-aside-whatsapp-button"
                                    className="flex items-center justify-center gap-2 rounded-full border border-ivory/30 px-6 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:border-brass hover:text-brass"
                                >
                                    WhatsApp Us
                                </a>
                            </div>
                            <p className="mt-8 flex items-center gap-2 text-xs text-ivory/50">
                                <Clock className="h-3.5 w-3.5 text-brass" />
                                {CONTACT.hours}
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <ul className="mt-8 space-y-5">
                            {ASSURANCES.map((a) => (
                                <li key={a.text} className="flex items-start gap-3 text-sm leading-relaxed text-steel" data-testid="book-assurance-item">
                                    <a.icon className="mt-0.5 h-4 w-4 shrink-0 text-brass-dark" />
                                    {a.text}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </div>
        </section>
    </>
);

export default Book;
